import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HomeTitles } from '@modules/home/models/home-titles.model';
import { GoogleAnalyticsService } from './googleanalytics.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleanalyticsmoduleserviceService {

  constructor(private googleAnalyticsService: GoogleAnalyticsService) { }

  sendDataToAnalyticsOnLegalSubmit(oktaAuthenticated:boolean) {
    const eventData = {
      event: "login_event",
      'content_type': 'Global Asset Hub',
      'division': 'B2B',
      'site_country': 'US',
      'page_name': 'License Terms and Conditions'
    };
    if(oktaAuthenticated) {
      eventData['intent_click'] = 'Login with Okta';
    }
    else {
      eventData['intent_click'] = 'Login with Platform Services';
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnHomePageView() {
    const eventData = {
      event: "pageview",
      'content_type': 'Global Asset Hub', 
      'division': 'B2B',
      'site_country': 'US',
      'page_name': "Homepage"
    };
    eventData['event_source'] = this.googleAnalyticsService.getEventSource();
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  getDateValue(dateString: string): Date {
    let dateValue: Date;
  
    if (dateString.includes('T')) {
      // Date is likely in ISO 8601 format 'yyyy-mm-ddTHH:mm:ss.SSSZ'
      const dateParts = dateString.split('T')[0].split('-');
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed in JavaScript Date object
      const day = parseInt(dateParts[2], 10);
      dateValue = new Date(year, month, day);
    } else {
      // Date is likely in 'yyyy-mm-dd' format
      const dateParts = dateString.split('-');
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed in JavaScript Date object
      const day = parseInt(dateParts[2], 10);
      dateValue = new Date(year, month, day);
    }
  
    return dateValue;
  }

  sendDataToAnalyticsOnHomePageTitleClick(title: HomeTitles, isNewAssets:boolean) {
    var section:string = null;
    const currentDate = new Date();
    const eventData = {
      event: "click_event",
      'content_type': 'Global Asset Hub', 
      'division': 'B2B',
      'site_country': 'US',
      'page_name' : "Assets - "+title.titleName,
      'intent_click': "View Assets"
    };

    if (isNewAssets) {
      section = 'New Assets';
      if(title.releaseDt) {
        const dateValue = new Date(title.releaseDt);
        if (dateValue <= new Date()) {
          eventData['release_status'] = "Released"; 
        } else if (dateValue > new Date()) {
          eventData['release_status'] = "Coming Soon";
        }
      }
    }
    else {     
      const releaseDate = title.releaseDate;
      const dateToCompare = new Date(releaseDate);
      if (dateToCompare > currentDate) {
        section = 'Coming Soon';
      } else if (dateToCompare <= currentDate) {
        section = 'Released';
      } 
      if(title.releaseDate) {
        const dateValue = new Date(title.releaseDate);
        if (dateValue <= new Date()) {
          eventData['release_status'] = "Released"; 
        } else if (dateValue > new Date()) {
          eventData['release_status'] = "Coming Soon";
        } 
      }
    }
    eventData['page_section'] = section; 
    if(title.gpmsProductId) {
      eventData['gpms_id'] = title.gpmsProductId; 
    }
    if(title.titleName) {
      eventData['property_title'] = title.titleName; 
    }
    if(title.localTitleName) {
      eventData['local_title'] = title.localTitleName; 
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnAssetsScreen(originalTitleName:string, eventSource:string,
    titleOverview: any, titleName:string) {
    const eventData = {
      event: "pageview",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',
      'page_name' : "Assets - "+originalTitleName,
      'event_source': eventSource
    };
    if(titleOverview.releaseDate) {
      const dateValue = new Date(titleOverview.releaseDate);
      if (dateValue <= new Date()) {
        eventData['release_status'] = "Released"; 
      } else if (dateValue > new Date()) {
        eventData['release_status'] = "Coming Soon";
      }
    }
    if(titleName) {
      eventData['local_title'] = titleName;
    }
    if(titleOverview?.gpmsProductId) {
      eventData['gpms_id'] = titleOverview?.gpmsProductId;
    }
    if(originalTitleName) {
      eventData['property_title'] = originalTitleName;
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnOverviewScreen(originalTitleName:string, eventSource:string,
    titleOverview: any,genreCast: any, titleName:string) {
    const eventData = {
      event: "pageview",
      'content_type': 'Global Asset Hub', 
      'division': 'B2B',
      'site_country': 'US',
      'page_name' : 'Overview - '+originalTitleName
    };
    if(titleOverview?.gpmsProductId) {
      eventData['gpms_id'] = titleOverview?.gpmsProductId;
    }
    if(genreCast?.GenreType?.genre) {
      eventData['genres'] = genreCast?.GenreType?.genre.join(', ');
    }
    if(titleName) {
      eventData['local_title'] = titleName;
    }
    if(originalTitleName) {
      eventData['property_title'] = originalTitleName;
    }
    if(titleOverview.releaseDate) {
      const dateValue = new Date(titleOverview.releaseDate);
      if (dateValue <= new Date()) {
        eventData['release_status'] = "Released"; 
      } else if (dateValue > new Date()) {
        eventData['release_status'] = "Coming Soon";
      }
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }
  
  sendDataToAnalyticsOnCartEvents(selectedAssets:any, intentClick:string, url?:any) {
    const eventData = {
      event: "cart_event",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',
      'page_name':'Assets - ' +selectedAssets.original_title_name,
      'intent_click' : intentClick,
      'runner_id': selectedAssets.runner_id.toString()
    };
    if(intentClick == 'Add to Cart - Bulk Operation') {
      eventData['page_section'] = 'Action Bar - Cart Icon';
    }
    else if(intentClick == 'Preview - Add To Cart') {
      eventData['page_section'] = 'Preview - Cart Icon';
      eventData['intent_click'] = 'Add to Cart - Individual Operation';
    }
    else {
      eventData['page_section']   = selectedAssets.asset_category.trim().replaceAll('~', ' » ')+ ' - Asset Card - Cart Icon';
    }

    if(selectedAssets.original_title_name) {
      eventData['property_title'] = selectedAssets.original_title_name;
    }
    if(selectedAssets.title_name) {
      eventData['local_title'] = selectedAssets.title_name;
    }
    if(selectedAssets.asset_category) {
      eventData['asset_category'] = selectedAssets.asset_category.trim().replaceAll('~', ' » ');
    }
    if(selectedAssets.file_name) {
      eventData['asset_type'] = selectedAssets.file_name.split('.').pop();
    }
    if(selectedAssets.filename) {
      eventData['asset_type'] = selectedAssets.filename.split('.').pop();
    }
    if(selectedAssets?.gpms_id) {
      eventData['gpms_id'] = selectedAssets?.gpms_id;
    }
    if(selectedAssets.file_name) {
      eventData['asset_type'] = selectedAssets.file_name.split('.').pop();
    }
    if(selectedAssets.release_dt) {
      const dateValue = new Date(selectedAssets.release_dt);
      if (dateValue <= new Date()) {
        eventData['release_status'] = "Released"; 
      } else if (dateValue > new Date()) {
        eventData['release_status'] = "Coming Soon";
      }
    }
    if(url && url.toString().includes("assetView")) {
      eventData['share_link'] = environment.apiUrl?.split('/g')[0] + url;
    }
    if(selectedAssets.thumbnail_url) {
      eventData['thumbnail_url'] = selectedAssets.thumbnail_url;
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnAssetDownloadButtonClick(assetInfo:any, assetFileName:string, titleName:string,
    downloadType:string, proxyType:string, screenType: string, url:any) {
    const eventData = {
      event: "download_event",
      'content_type': 'Global Asset Hub', 
      'division': 'B2B',
      'site_country': 'US',
      'intent_click': "Download - Individual Operation",
      'page_name' : 'Download Options - Popup'
    };
    if(assetInfo && assetInfo.asset_category && screenType) {
      eventData['page_section'] = 'Preview - Download Icon';
    }
    else {
      eventData['page_section'] = assetInfo.asset_category.trim().replaceAll('~', ' » ')+ ' - Asset Card - Download Icon';
    }
    if(assetInfo?.gpms_id) {
      eventData['gpms_id'] = assetInfo?.gpms_id;
    }
    
    if(assetInfo.original_title_name) {
      eventData['property_title'] = assetInfo.original_title_name;
    }
    if(titleName) {
      eventData['property_title'] = titleName;
    }
    if(assetInfo.title_name) {
      eventData['local_title'] = assetInfo.title_name;
    }
    
    if(assetInfo.runner_id) {
      eventData['runner_id'] = assetInfo.runner_id.toString();
    }
    if(assetInfo && assetInfo.asset_category) {
      eventData['asset_category'] = assetInfo.asset_category.trim().replaceAll('~', ' » ');
    }
    if(assetFileName) {
      eventData['asset_type'] = assetFileName.split('.').pop();
    }
   
    if(assetInfo && assetInfo.height && assetInfo.width) {
      eventData['asset_size'] = assetInfo.height?.toString() + ' X '+assetInfo.width?.toString();
    }
    if(downloadType) {
      eventData['download_method'] = downloadType;
    }
    if(proxyType && proxyType == 'original') {
      eventData['asset_resolution_type'] = 'High Resolution';
    }
    else {
      eventData['asset_resolution_type'] = 'Standard Resolution';
    }
    if(url && url.toString().includes("assetView")) {
      eventData['page_name'] = 'Assets - Shared Link';
      eventData['page_section'] = 'Individual Download Icon';
      eventData['share_link'] = environment.apiUrl?.split('/g')[0] + url;
    }
    if(assetInfo.release_dt) {
      const dateValue = new Date(assetInfo.release_dt);
      if (dateValue <= new Date()) {
        eventData['release_status'] = "Released"; 
      } else if (dateValue > new Date()) {
        eventData['release_status'] = "Coming Soon";
      }
    }
    if(assetInfo.thumbnail_url) {
      eventData['thumbnail_url'] = assetInfo.thumbnail_url.toString();
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnBulkDownloadCart(downloadFileData:any[], downloadMethod:string, assetProxyType:string, operation:string, url:any) {
    downloadFileData.forEach(element => {
      const eventData = {
        event: "download_event",
        'intent_click': "Download - Bulk Operation",
        'content_type': 'Global Asset Hub', 
        'division': 'B2B',
        'site_country': 'US',
        'page_name': 'Cart Checkout',
        'page_section' : 'Cart - Download Icon',
        'runner_id': element.runner_id.toString(),
        'asset_size': element.height +' X '+element.width,
        'download_method': downloadMethod
      };
      if(element.original_title_name) {
        eventData['property_title'] = element.original_title_name;
      }
      if(element.title_name) {
        eventData['local_title'] = element.title_name;
      }
      if(operation) {
        eventData['page_name'] = 'Assets- '+element.original_title_name;
        eventData['page_section'] = 'Action Bar - Download Icon';
      }
      if(element.asset_size) {
        eventData['asset_size'] = element.asset_size;
      }
      if(element.asset_category) {
        eventData['asset_category'] = element.asset_category.trim().replaceAll('~', ' » ');
      }
      if(assetProxyType && assetProxyType == 'original') {
        eventData['asset_resolution_type'] = 'High Resolution';
      }
      else {
        eventData['asset_resolution_type'] = 'Standard Resolution';
      }
      if(element?.file_name) {
        eventData['asset_type'] = element.file_name.split('.').pop();
      }
      if(element?.gpms_id) {
        eventData['gpms_id'] = element.gpms_id;
      }
      if(url) {
        eventData['page_name'] = 'Assets - Shared Link';
        eventData['page_section'] = 'Bulk Download Icon';
        eventData['share_link'] = environment.apiUrl?.split('/g')[0] + url;
      }
      if(element.release_dt) {
        const dateValue = new Date(element.release_dt);
        if (dateValue <= new Date()) {
          eventData['release_status'] = "Released"; 
        } else if (dateValue > new Date()) {
          eventData['release_status'] = "Coming Soon";
        }
      }
      if(element.thumbnail_url) {
        eventData['thumbnail_url'] = element.thumbnail_url;
      }
      this.googleAnalyticsService.sendDataToAnalytics(eventData);
    });
  }

  sendDataToAnalyticsOnItemLinkShareEvents(asset:any, sharePermissionCode:string, expirationDate:any, 
      email:string, intentClick:string, operation:string, url?:string) { 
    const eventData = {
      event: "share_event",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',    
      'asset_size': asset.height?.toString() + ' X '+asset.width?.toString()
    };
    if(asset.assetCategory) {
      eventData['asset_category'] = asset.assetCategory.trim().replaceAll('~', ' » ');
    }
    if(asset.asset_category) {
      eventData['asset_category'] = asset.asset_category.trim().replaceAll('~', ' » ');
    }
    if(operation == "Cart") {
      eventData['page_name'] = 'Cart Checkout';
      eventData['page_section'] = 'Cart - Share Link Icon';
      eventData['intent_click'] = 'Share Link - Bulk Operation';
    }
  
    else if(operation == "Action Bar") {
      eventData['page_name'] = 'Assets- '+asset.original_title_name;
      eventData['page_section'] = 'Action Bar - Share Link Icon';  
      eventData['intent_click'] = 'Share Link - Bulk Operation';
    }
    else {
      eventData['page_name'] = 'Share Link - Popup';
      eventData['intent_click'] = 'Share Link - Individual Operation';
      if(intentClick == 'Copy') {
        eventData['page_section'] = 'Share Link - Popup - Copy';
      }
      else if(intentClick == 'Generate Link') {
        eventData['page_section'] = eventData['asset_category']+' - Asset Card - Share Link Icon';
      }
      else if(intentClick == 'Email') {
        eventData['page_section'] = 'Share Link - Popup - Email';
      }
    }
    if(asset.original_title_name) {
      eventData['property_title'] = asset.original_title_name;
    }
    if(asset.title_name) {
      eventData['local_title'] = asset.title_name;
    }
    if(asset.operation) {
      eventData['intent_click'] = asset.operation;
    }
    else if(intentClick) {
      eventData['intent_click'] = intentClick;
    }
    if(asset.release_dt) {
      const dateValue = new Date(asset.release_dt);
      if (dateValue <= new Date()) {
        eventData['release_status'] = "Released"; 
      } else if (dateValue > new Date()) {
        eventData['release_status'] = "Coming Soon";
      }
      
      if(url) {
        eventData['share_link'] = url;
      }
    }
    if(sharePermissionCode) {
      if(sharePermissionCode == 'D') {
        eventData['download_permission'] = 'Download';
      }
      if(sharePermissionCode == 'PO') {
        eventData['download_permission'] = 'Preview Only';
      }
      if(sharePermissionCode == 'POD') {
        eventData['download_permission'] = 'Proxy Download';
      }
    }
    if(email) {
      eventData['protected_link'] = 'Yes'; 
    }
    else {
      eventData['protected_link'] = 'No';
    }
    if(expirationDate) {
      eventData['link_expiration'] = expirationDate.toString();
    }
    if(asset?.gpms_id) {
      eventData['gpms_id'] = asset?.gpms_id;
    }
    
    eventData['asset_type'] = asset.file_name ? asset.file_name.toLowerCase().split('.').pop() : asset.fileName.toLowerCase().split('.').pop();
    eventData['runner_id']  = asset.runner_id ? asset.runner_id.toString() : asset.runnerId.toString();

    if(asset?.thumbnail_url) {
      eventData['thumbnail_url'] = asset?.thumbnail_url;
    }
    
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnClickOfEmailShare(asset:any, sharePermissionCode:string, expirationDate:any, 
    intentClick:string) {   
  const eventData = {
    event: "share_event",
    'content_type': 'Global Asset Hub', 
    'site_country': 'US',
    'division': 'B2B',    
    'page_name': 'Email Share',
    'user_group':'Exhibitor Relations',
    'user_country':'United States',
    'runner_id': asset.runner_id?.toString(),
    'asset_size': asset.height?.toString() + ' X '+asset.width?.toString()
  };
  if(asset?.original_title_name) {
    eventData['property_title'] = asset.original_title_name;
  }

  if(asset?.title_name) {
    eventData['local_title'] = asset.title_name;
  }

  if(asset.assetCategory) {
    eventData['asset_category'] = asset.assetCategory.trim().replaceAll('~', ' » ');
  }

  if(asset.asset_category) {
    eventData['asset_category'] = asset.asset_category.trim().replaceAll('~', ' » ');
  }
 
  eventData['intent_click'] = 'Email Share - Bulk Operation';
  if(intentClick == 'Digital Cart') {
    eventData['page_section'] = 'Digital Cart - Email Share Icon';
  }
  else {
    eventData['page_section'] = 'Action Bar - Email Share Icon';
  }

  if(sharePermissionCode) {
    if(sharePermissionCode == 'D') {
      eventData['download_permission'] = 'Download';
    }
    if(sharePermissionCode == 'PO') {
      eventData['download_permission'] = 'Preview Only';
    }
    if(sharePermissionCode == 'POD') {
      eventData['download_permission'] = 'Proxy Download';
    }
  }
  if(expirationDate) {
    eventData['link_expiration'] = expirationDate?.toString();
  }
  if(asset?.gpms_id) {
    eventData['gpms_id'] = asset?.gpms_id;
  }
  eventData['asset_type'] = asset.file_name ? asset.file_name?.toLowerCase().split('.').pop() : asset.fileName?.toLowerCase().split('.').pop();
  eventData['runner_id']  = asset.runner_id ? asset.runner_id?.toString() : asset.runnerId?.toString();
  if(asset.release_dt) {
    const dateValue = new Date(asset.release_dt);
    if (dateValue <= new Date()) {
      eventData['release_status'] = "Released"; 
    } else if (dateValue > new Date()) {
      eventData['release_status'] = "Coming Soon";
    }
  }
  if(asset?.thumbnail_url) {
    eventData['thumbnail_url'] = asset?.thumbnail_url;
  }
  this.googleAnalyticsService.sendDataToAnalytics(eventData);
}

sendDataToAnalyticsOnClickOfShareLink(asset:any, sharePermissionCode:string, expirationDate:any, 
  protectedByEmail: boolean) {   
      const eventData = {
        event: "pageview",
        'content_type': 'Global Asset Hub', 
        'site_country': 'US',
        'division': 'B2B',    
        'property_title': asset.title_name,
        'page_name': 'Assets - Shared Link',
        'page_section': 'Asset View',
        'user_group':'Exhibitor Relations',
        'user_country':'United States',
        'user_type': 'Internal',
        'runner_id': asset.runner_id?.toString(),
        'asset_size': asset.height?.toString() + ' X '+asset.width?.toString()
      };
      if(asset?.titleName) {
        eventData['property_title'] = asset.titleName;
      }

      if(asset.asset_category) {
        eventData['asset_category'] = asset.asset_category.trim().replaceAll('~', ' » ');
      }
      if(asset.original_title_name) {
        eventData['property_title'] = asset.original_title_name;
      }

      eventData['intent_click'] = 'Asset View - Link Share';

      if(protectedByEmail)
        eventData['protected_link'] = 'Yes';
      else
        eventData['protected_link'] = 'No';

      if(sharePermissionCode) {
        if(sharePermissionCode == 'D') {
          eventData['download_permission'] = 'Download';
        }
        if(sharePermissionCode == 'PO') {
          eventData['download_permission'] = 'Preview Only';
        }
        if(sharePermissionCode == 'POD') {
          eventData['download_permission'] = 'Proxy Download';
        }
      }
      if(expirationDate) {
        const dateValue = new Date(expirationDate?.toString());
        eventData['link_expiration'] = dateValue;
      }
      if(asset?.gpms_id) {
        eventData['gpms_id'] = asset?.gpms_id;
      }
      eventData['asset_type'] = asset.file_name ? asset.file_name?.toLowerCase().split('.').pop() : asset.fileName?.toLowerCase().split('.').pop();
      eventData['runner_id']  = asset.runner_id ? asset.runner_id?.toString() : asset.runnerId?.toString();
      if(asset?.thumbnail_url) {
        eventData['thumbnail_url'] = asset?.thumbnail_url;
      }
      this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnClickOfAssetDetails(asset:any, sharePermissionCode:string, expirationDate:any, 
    protectedByEmail: boolean, url:string) {   
    const eventData = {
      event: "pageview",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',  
      'page_name': 'Preview Asset - Shared Link',
      'page_section': 'Preview Icon',
      'user_group':'Exhibitor Relations',
      'user_country':'United States',
      'user_type': 'Internal',
      'runner_id': asset.runner_id?.toString(),
      'asset_size': asset.height?.toString() + ' X '+asset.width?.toString()
    };
    if(asset?.titleName) {
      eventData['property_title'] = asset.titleName;
    }
  
    if(asset.asset_category) {
      eventData['asset_category'] = asset.asset_category.trim().replaceAll('~', ' » ');
    }
    if(asset.original_title_name) {
      eventData['property_title'] = asset.original_title_name;
    }
  
    eventData['email_required'] = protectedByEmail;
  
    if(sharePermissionCode) {
      if(sharePermissionCode == 'D') {
        eventData['download_permission'] = 'Download';
      }
      if(sharePermissionCode == 'PO') {
        eventData['download_permission'] = 'Preview Only';
      }
      if(sharePermissionCode == 'POD') {
        eventData['download_permission'] = 'Proxy Download';
      }
    }
    if(expirationDate) {
      eventData['link_expiration'] = expirationDate?.toString();
    }
    if(asset?.gpms_id) {
      eventData['gpms_id'] = asset?.gpms_id;
    }
    eventData['asset_type'] = asset.file_name ? asset.file_name?.toLowerCase().split('.').pop() : asset.fileName?.toLowerCase().split('.').pop();
    eventData['runner_id']  = asset.runner_id ? asset.runner_id?.toString() : asset.runnerId?.toString();
    if(asset?.title_name) {
      eventData['local_title'] = asset?.title_name;
    }
    if(asset.release_dt) {
      const dateValue = new Date(asset.release_dt);
      if (dateValue <= new Date()) {
        eventData['release_status'] = "Released"; 
      } else if (dateValue > new Date()) {
        eventData['release_status'] = "Coming Soon";
      }
    }
    if(url) {
      eventData['share_link'] = environment.apiUrl?.split('/g')[0] + url;
    }
    if(asset.thumbnail_url) {
      eventData['thumbnail_url'] = asset.thumbnail_url;
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
    }

    sendDataToAnalyticsOnClickOfAssetPreview(asset:any) { 
      const eventData = {
        event: "pageview",
        'content_type': 'Global Asset Hub', 
        'site_country': 'US',
        'division': 'B2B',  
        'page_name': 'Preview Asset',
        'user_group':'Exhibitor Relations',
        'user_country':'United States',
        'user_type': 'Internal',
        'runner_id': asset.runner_id?.toString(),
        'asset_size': asset.height?.toString() + ' X '+asset.width?.toString()
      };
      if(asset?.titleName) {
        eventData['property_title'] = asset.titleName;
      }
    
      if(asset.asset_category) {
        eventData['asset_category'] = asset.asset_category.trim().replaceAll('~', ' » ');
      }
      if(asset.original_title_name) {
        eventData['property_title'] = asset.original_title_name;
      }
    
      if(asset?.gpms_id) {
        eventData['gpms_id'] = asset?.gpms_id;
      }
      eventData['asset_type'] = asset.file_name ? asset.file_name?.toLowerCase().split('.').pop() : asset.fileName?.toLowerCase().split('.').pop();
      eventData['runner_id']  = asset.runner_id ? asset.runner_id?.toString() : asset.runnerId?.toString();
      if(asset?.title_name) {
        eventData['local_title'] = asset?.title_name;
      }
      if(asset.release_dt) {
        const dateValue = new Date(asset.release_dt);
        if (dateValue <= new Date()) {
          eventData['release_status'] = "Released"; 
        } else if (dateValue > new Date()) {
          eventData['release_status'] = "Coming Soon";
        }
      }
      if(asset?.thumbnail_url) {
        eventData['thumbnail_url'] = asset?.thumbnail_url;
      }
   
      this.googleAnalyticsService.sendDataToAnalytics(eventData);
      }
}